module.exports = __webpack_public_path__ + "img/1f966.787dc5a.svg";